import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-filled-chevron-down';
export var ID = 'icon-filled-chevron-down';
export var SVGFilledChevronDown = function SVGFilledChevronDown() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    fill: "#6D6565"
  }, React.createElement("polygon", {
    points: "8 10 12 6 4 6"
  }))));
};

var FilledChevronDown = function FilledChevronDown(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGFilledChevronDown
  });
};

FilledChevronDown.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default FilledChevronDown;